/* eslint-disable import/prefer-default-export,no-debugger */
import { CONVERSIONS } from '../../constants';

export const makeId = (length: number) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const charactersLength = characters.length;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getNextId = <T extends { id: number }>(x: T[]): number => (
  x.length === 0
    ? 0
    : Math.max(...x.map(({ id }) => id)) + 1);

export const idFilter = <T extends { id: number }>(x: T, y: Partial<T>): boolean => x.id === y.id;

export const findIndex = <T>(item: Partial<T>, list: T[], filter: (x: T, y: Partial<T>) => boolean): number => {
  for (let i = 0; i < list.length; i += 1) {
    if (filter(list[i], item)) {
      return i;
    }
  }
  return -1;
};

export const splice = <T>(list: T[], { index, qty = 1 }:{ index: number, qty?: number }, ...elements: T[]) => {
  const isOutOfBounds = (index + qty) > (list.length);
  const part0 = isOutOfBounds ? [] : list.slice(0, index);
  const indexFrom = isOutOfBounds ? (index + qty - list.length) : index + qty;
  const indexTo = isOutOfBounds ? (index) : undefined;
  const part1 = list.slice(indexFrom, indexTo);
  return [...part0, ...elements, ...part1];
};

export const toFeet = (inches: number) => inches / CONVERSIONS.FEET_TO_INCH;
export const toInches = (feets: number) => feets * CONVERSIONS.FEET_TO_INCH;
export const ACCURACY = toFeet(1);

export const formatLabel = (prefix: string | undefined, value: number) => {
  if (prefix) {
    return `${prefix} ${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} `;
  }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getTime = () => `${new Date().getHours()}-${new Date().getMinutes()}-${new Date().getSeconds()}`;

export const download = (content: any, fileName: string, contentType: string) => {
  const a = document.createElement('a');
  const file = new Blob([content], { type: contentType });
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
};

export const downloadFromUrl = (url: string, fileName: string) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
};

export const getMaxFromList = (list: number[]) => Math.max(...list);
